import type * as Matter from 'matter-js';

export interface TraceHistory {
  points: { x: number; y: number }[];
}

export function pushTracePoint(history: TraceHistory, body: Matter.Body, maxPoints = 200): void {
  history.points.push({ x: body.position.x, y: body.position.y });
  if (history.points.length > maxPoints) history.points.shift();
}

export function drawTrace(
  ctx: CanvasRenderingContext2D,
  history: TraceHistory,
  color: string,
): void {
  if (history.points.length < 2) return;
  ctx.save();
  ctx.strokeStyle = color;
  ctx.lineWidth = 1.5;
  ctx.setLineDash([4, 4]);
  ctx.beginPath();
  const first = history.points[0]!;
  ctx.moveTo(first.x, first.y);
  for (let i = 1; i < history.points.length; i++) {
    const p = history.points[i]!;
    ctx.lineTo(p.x, p.y);
  }
  ctx.stroke();
  ctx.restore();
}
